'use strict';

var angular = require('angular');

import '../app';
import './rebindDirective';
import './emitLastRepeaterElement';
import './fadeIn';